<template>
	<CModal
		v-if="item"
		:key="item.id"
		:show.sync="isShow"
		:close-on-backdrop="false"
		centered
		class="modal-resolved-issue"
	>
		<template #header-wrapper>
			<ModalHeaderWrapper
				:title="title"
				@onClose="handleCancel"
			/>
		</template>
		<template #default>
			<CForm class="main-wrapper form-standard">
				<CRow
					:gutters="false"
					align-horizontal="between"
				>
					<CCol lg="12" class="mb-3">
						<CRow class="d-flex align-items-center">
							<CCol class="typo-label">
								{{ $t('message.issueStatus') }}
							</CCol>
							<CCol class="mr-0">
								<CBadge
									class="badge-status"
									:color="status === 'opening' ? 'danger' : 'success'"
								>
									{{ status }}
								</CBadge>
							</CCol>
						</CRow>
					</CCol>
					<CCol lg="12" class="mb-3">
						<CRow class="d-flex align-items-center">
							<CCol class="typo-label">
								{{ $t('message.issueId') }}
							</CCol>
							<CCol class="mr-0">
								{{ item.id }}
							</CCol>
						</CRow>
					</CCol>
					<CCol lg="12" class="mb-3">
						<CRow class="d-flex align-items-center">
							<CCol class="typo-label">
								{{ $t('message.issueType') }}
							</CCol>
							<CCol class="mr-0">
								{{ ERROR_TITLE.ERROR[item.type] }}
							</CCol>
						</CRow>
					</CCol>
					<CCol lg="12" class="mb-3">
						<CRow class="d-flex">
							<CCol class="typo-label">
								{{ $t('message.issueSummary') }}
							</CCol>
							<CCol class="mr-0">
								{{ item.message }}
							</CCol>
						</CRow>
					</CCol>
					<CCol lg="12" class="mb-3">
						<CRow class="d-flex align-items-center">
							<CCol class="typo-label">
								{{ $t('message.issueReportedDate') }}
							</CCol>
							<CCol class="mr-0">
								{{ item.reportedAt }}
							</CCol>
						</CRow>
					</CCol>
					<CCol lg="12">
						<CTextarea
							v-if="resolvedStatus"
							v-model="remarkContent"
							:class="[resolvedStatus ? 'resolved-txt-area' : '']"
							:label="$t('message.remark')"
							rows="3"
						/>
						<CTextarea
							v-else
							v-model="remark"
							:label="$t('message.remark')"
							rows="3"
						/>
					</CCol>
					<CCol v-if="resolvedStatus">
						<p class="user-info">
							Resolved by <span class="full-name">{{ fullName }}</span> <span>|</span> {{ resolvedDate }}
						</p>
					</CCol>
				</CRow>
			</CForm>
		</template>
		<template #footer>
			<CButton
				v-if="resolvedStatus"
				class="btn-tertiary"
				@click="handleCancel"
			>
				{{ $t('button.close') }}
			</CButton>
			<CButton
				v-else
				:disabled="isLoading"
				color="warning"
				@click="handleSubmit"
			>
				<span
					v-if="isLoading"
					class="spinner-border spinner-border-sm mr-2"
					role="status"
					aria-hidden="true"
				>
				</span>
				{{ $t('button.resolve') }}
			</CButton>
		</template>
	</CModal>
</template>

<script>
import { ERROR_TITLE } from '../enums/error';

export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		status: {
			type: String,
			default: '',
		},
		item: {
			type: Object,
			default: () => {},
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			ERROR_TITLE,

			isShow: false,
			remark: null,
		};
	},
	computed: {
		remarkContent() {
			return this.item.remark || '-';
		},
		resolvedStatus() {
			return this.status === 'resolved';
		},
		fullName() {
			return `${this.item.resolvedBy.first_name} ${this.item.resolvedBy.last_name || ''}`;
		},
		resolvedDate() {
			return this.item.resolvedAt;
		},
	},
	methods: {
		open() {
			this.isShow = true;
		},
		close() {
			this.isShow = false;
		},
		handleSubmit() {
			const data = {
				id: this.item.id,
				remark: this.remark,
			};
			this.$emit('onSubmit', data);
		},
		handleCancel() {
			this.$emit('onCancel');
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog {
	max-width: rem(500);

	.typo-label {
		flex-grow: 0;
		flex-basis: 30%;
	}

	.user-info {
		color: $color-black-45;
		font-size: rem(12);
		font-weight: 500;
	}

	.full-name {
		color: $color-hypertext;
	}

	.resolved-txt-area {
		&.form-group {
			margin-bottom: 0;
		}

		.form-control {
			border: none;
			height: rem(30);
			padding: 0;
		}
	}
}
</style>
